import { I18n } from 'aws-amplify'

I18n.putVocabulariesForLanguage('es', {
  'Sign in to your account': 'Iniciar sesíon',
  'Loading...': 'Cargando...',
  'Confirmation Code': 'Codigo de confirmación',
  'Sign In': 'Iniciar sesíon',
  'Sign In ': 'Iniciar sesíon',
  'Sign Up': 'Regístrase',
  'Sign Out': 'Desconectar',
  'Forgot Password': 'Se te olvidó la contraseña?',
  Username: 'Nombre de usuario',
  Password: 'Contraseña',
  'Change Password': 'Cambia la contraseña',
  'New Password': 'Nueva contraseña',
  Email: 'Email',
  'Phone Number': 'Número de teléfono',
  'Resend Code': 'Mandar codigo otra vez',
  'Create a new account': 'Crear una cuenta nueva',
  'Confirm a Code': 'Confirmar un código',
  'Confirm Sign In': 'Confirmar inicio de sesión',
  'Confirm Sign Up': 'Confirmar Registración',
  'Back to Sign In': 'Iniciar sesión',
  'Send Code': 'Enviar código',
  Confirm: 'Confirmar',
  'Resend a Code': 'Reenviar un código',
  Submit: 'Enviar',
  Skip: 'Omitir',
  Verify: 'Verificar',
  'Verify Contact': 'Verificar contacto',
  Code: 'Código',
  'Account recovery requires verified contact information':
    'La recuperación de la cuenta requiere información de contacto verificada',
  'Username cannot be empty': 'El campo de usuario no puede estar vacido',
  'User does not exist.': 'El usuario no existe.',
  'Sign in': 'Ingresar ',
  'Signing in': 'Ingresando ... ',
  'User already exists': 'El usuario ya existe',
  'Incorrect username or password.':
    'Nombre de usuario o contraseña incorrecta.',
  'Invalid password format': 'Formato de contraseña inválido',
  'Invalid phone number format':
    'Formato de n\xFAmero de tel\xE9fono inv\xE1lido.\nUtilice el formato de n\xFAmero de tel\xE9fono +12345678900'
})
I18n.setLanguage('es')
